module.exports = __webpack_public_path__ + "static/media/building_damage_assessment.20c3397e.jpg";